module.exports = __webpack_public_path__ + "img/osu.77a92eec.png";